import React from 'react';

import { useIntl } from 'react-intl-next';

import ErrorIcon from '@atlaskit/icon/core/migration/error';
import { VerifiedTeamIcon } from '@atlaskit/people-teams-ui-public/verified-team-icon';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, Inline, Text } from '@atlaskit/primitives/compiled';
import Tooltip from '@atlaskit/tooltip';
import { Skeleton } from '@atlassian/eoc-skeleton';

import messages from './messages';
import { DeletedEntity, IdText, ResponderName } from './styled';
import { type ResponderProps } from './types';

export const Responder = ({ data, inlineResponder }: ResponderProps) => {
	const { formatMessage } = useIntl();

	if (inlineResponder) {
		if (fg('display_eoc_managed_teams_with_verified_marks')) {
			const showVerifiedIcon = inlineResponder.type === 'team' && inlineResponder.verified;

			if (showVerifiedIcon) {
				return (
					<Inline space="space.050" alignBlock="center">
						<Text as="strong">{inlineResponder.label}</Text>
						<VerifiedTeamIcon />
					</Inline>
				);
			}
		}
		return <Text as="strong">{inlineResponder.label}</Text>;
	}

	if (data.isLoading) {
		return <Skeleton width={5} />;
	}

	if (data.isError) {
		return (
			<IdText>
				<Tooltip position="top-start" content={data.id}>
					<span>{data.id}</span>
				</Tooltip>
			</IdText>
		);
	}

	if (data.deleted) {
		return (
			<DeletedEntity alignItems="center">
				<ErrorIcon color="currentColor" spacing="spacious" label="" />
				<Box as="span">{formatMessage(messages.deletedEntity)}</Box>
			</DeletedEntity>
		);
	}

	if (fg('display_eoc_managed_teams_with_verified_marks')) {
		const showVerifiedIcon = data.type === 'team' && data.verified;

		if (showVerifiedIcon) {
			return (
				<Inline space="space.050" alignBlock="center">
					<ResponderName>{data.name}</ResponderName>
					<VerifiedTeamIcon />
				</Inline>
			);
		}
	}

	return <ResponderName>{data.name}</ResponderName>;
};
